<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right"
                   style="font-size: 20px; padding: 20px 10px 20px; background-color: #e6e5e5;">
      <el-breadcrumb-item>Generation</el-breadcrumb-item>
      <el-breadcrumb-item>Linker design</el-breadcrumb-item>
    </el-breadcrumb>
    <div>
      <p class="content">
          The Linker-design module supports fragment linking within AIDrugDesigner for
          fragment-based drug discovery and related applications such as PROTAC design.
          Users provide two molecular fragments and specify desired linker constraints,
          including linker length, aromatic ring count, and hydrogen bond donor and acceptor
          numbers. An integrated graph-based generative framework constructs linkers that
          satisfy these constraints, and the assembled molecules are returned as SMILES
          strings with predicted properties and visualization results.
      </p>
    </div>

    <linker-design-form></linker-design-form>
  </div>
</template>


<script>
import LinkerDesignForm from "@/components/LinkerDesignForm";
import OCL from 'openchemlib';
import { ref, watch } from "vue";
const smiles = ref("c1ccccc1");

export default {
  name: "LinkerDesign",
  components: {LinkerDesignForm},
  data() {
    return {
    }
  },
  methods:{

  },
  created() {
    //this function will be called after the JavaScriptApplet code has been loaded.
    function jsmeOnLoad() {
      jsmeApplet = new JSApplet.JSME("jsme_container", "380px", "340px");
    }

  }

}

</script>

<style scoped>
div {
  max-width: 1160px;
  margin: 0 auto;
}
p {
  /*padding: 20px 0 20px;*/
  line-height: 1.5em;
  text-align: left!important;
}
.content{
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  background-color: RGB(255,255,255);
  border-radius: 10px;
  padding: 10px;
}
</style>
